function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#26a1f4",
    d: "M 232.5,-0.5 C 247.833,-0.5 263.167,-0.5 278.5,-0.5C 368.144,10.3879 435.644,54.7213 481,132.5C 497.695,163.971 507.861,197.304 511.5,232.5C 511.5,247.833 511.5,263.167 511.5,278.5C 500.612,368.144 456.279,435.644 378.5,481C 347.029,497.695 313.696,507.861 278.5,511.5C 263.167,511.5 247.833,511.5 232.5,511.5C 142.856,500.612 75.3562,456.279 30,378.5C 13.3053,347.029 3.1386,313.696 -0.5,278.5C -0.5,263.167 -0.5,247.833 -0.5,232.5C 10.3875,142.857 54.7208,75.3573 132.5,30C 163.971,13.3053 197.304,3.1386 232.5,-0.5 Z M 254.5,38.5 C 335.998,41.4825 398.498,77.1492 442,145.5C 473.311,200.964 479.978,259.297 462,320.5C 440.265,383.899 398.765,429.065 337.5,456C 251.311,486.972 173.978,472.306 105.5,412C 51.1458,356.595 30.3125,290.428 43,213.5C 63.8219,125.687 117.655,69.5205 204.5,45C 221.128,41.3389 237.795,39.1722 254.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#25a0f4",
    d: "M 345.5,117.5 C 353.704,116.462 361.371,117.962 368.5,122C 376,129.5 383.5,137 391,144.5C 397.325,154.386 397.658,164.386 392,174.5C 383.986,182.681 375.819,190.681 367.5,198.5C 349.5,181.167 331.833,163.5 314.5,145.5C 321.985,137.514 329.652,129.681 337.5,122C 340.099,120.205 342.766,118.705 345.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#26a1f4",
    d: "M 145.5,150.5 C 170.169,150.333 194.836,150.5 219.5,151C 235.05,155.294 240.217,165.127 235,180.5C 232.448,184.719 228.948,187.886 224.5,190C 201.566,191.469 178.566,191.969 155.5,191.5C 155.5,245.5 155.5,299.5 155.5,353.5C 209.5,353.5 263.5,353.5 317.5,353.5C 317.333,333.497 317.5,313.497 318,293.5C 323.945,279.283 334.111,275.116 348.5,281C 353.781,284.382 356.948,289.216 358,295.5C 358.667,318.167 358.667,340.833 358,363.5C 355.892,378.894 347.392,388.728 332.5,393C 268.5,393.667 204.5,393.667 140.5,393C 127.64,389.474 119.474,381.307 116,368.5C 115.333,304.5 115.333,240.5 116,176.5C 120.521,161.677 130.354,153.01 145.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#25a0f4",
    d: "M 303.5,155.5 C 304.552,155.351 305.552,155.517 306.5,156C 323.333,172.833 340.167,189.667 357,206.5C 357.667,207.5 357.667,208.5 357,209.5C 324.833,241.667 292.667,273.833 260.5,306C 256.993,308.254 253.327,310.254 249.5,312C 231.584,317.479 213.584,322.646 195.5,327.5C 188.252,326.092 185.085,321.759 186,314.5C 191.002,295.161 197.002,276.161 204,257.5C 205.667,255.167 207.333,252.833 209,250.5C 240.701,218.965 272.201,187.299 303.5,155.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditItem);
export default __webpack_public_path__ + "static/media/edit-item.463d29867306ce7b302e8be81e7e9916.svg";
export { ForwardRef as ReactComponent };